import { useNavigator } from '@repo/toolkit/use-navigator'
import Box from '@repo/ui/box'
import { EuroIcon } from '@repo/ui/icons'
import { useMutation } from '@tanstack/react-query'
import { toast } from 'sonner'

import { createPaymentCondition } from '../../api/payment-conditions/create-payment-condition'
import UserNavBar from '../../components/elements/nav-bar'
import PaymentConditionForm from '../../components/pages/payment-condition/payment-condition-form'
import { Paths } from '../../lib/constants/path'
import { twoButtonsConfig } from '../../lib/utils/buttons-config/validation-buttons-config'
import { showAxiosError } from '../../lib/utils/functions/misc.functions'

const PaymentConditionCreatePage = () => {
  const { navigate, back } = useNavigator()

  const { mutateAsync } = useMutation({
    mutationFn: createPaymentCondition,
    onError: showAxiosError,
    onSuccess: () => toast.success('Condition de paiement créée avec succès')
  })

  return (
    <div>
      <UserNavBar title={'Créer un condition de paiement'} icon={EuroIcon} />
      <div className={'h-4'} />

      <Box>
        <PaymentConditionForm
          buttonsConfig={twoButtonsConfig({
            onConfirm: async (values) => {
              const res = await mutateAsync(values)
              navigate(Paths.PAYMENT_CONDITIONS_UPDATE_PAGE.replace(':id', res.id.toString()), {
                replace: true
              })
            },
            onCancel: () => back()
          })}
        />
      </Box>
    </div>
  )
}

export default PaymentConditionCreatePage
